<template lang="pug">
  //- Barra de filtros de búsqueda
  .the-b2b-filters-component
    b2b-search-bar
      div.header(slot='header', v-if='showDatePicker')
        ods-date-picker(
          v-model='dateTimePickerValue',
          type='datetimerange',
          :picker-options='pickerOptions',
          @change='getDateTimePickerValue',
          :range-separator='$t("msg_generics.datepicker.separator")',
          :start-placeholder='$t("msg_generics.datepicker.start_placeholder")',
          :end-placeholder='$t("msg_generics.datepicker.end_placeholder")',
          value-format='yyyy-MM-ddTHH:mm:ss.SSS',
          align='right',
          :format='$t("date_format_long_datepicker")',
          :default-time="['00:00:00', '23:59:59']",
          prefix-icon='prefix-icon-date-time-picker',
          :showFooterButtons='true')
      div(slot='body')
        ods-form.the-b2b-filters-component__area(
          :model='filterForm',
          :rules='rules',
          ref='filterForm',
          @submit.native.prevent='')
          ods-form-item.first-input(prop='firstValue')
            //- b2b-select
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='filterForm.firstValue',
              :placeholder='$t("msg_generics.advanced_search")',
              @change='getFirstValue')
              ods-option(
                v-for='option in options',
                :key='option.col',
                :label='$t(option.value)',
                :disabled='option.selected',
                :value='option')
          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-show='filterForm.firstValue')
              //- Select type
              div(v-if="selected.componente === 'select'")
                ods-form-item.others-input(prop='secondValueSelect')
                  //- b2b-select
                  ods-select(
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.value',
                      :label='option.name',
                      :value='option')
              //- INVOICE NUMBER
              div(v-else-if="selected.componente === 'input' && (selected.prop === 'invoiceNumber')")
                ods-form-item.others-input(prop='invoiceNumber')
                  ods-input(
                    :placeholder='$t(selected.placeholder)',
                    v-model.trim='filterForm.invoiceNumber',
                    @input='getSecondValue')
              //- Input type
              div(v-else-if="selected.componente === 'input' && selected.tipo === 'string' && selected.prop !== 'invoiceNumber'")
                ods-form-item.others-input(prop='secondValue')
                  ods-input(
                    :placeholder='$t(selected.placeholder)',
                    v-model='filterForm.secondValue',
                    @input='getSecondValue')
              div(v-else-if="selected.componente === 'date' && selected.tipo === 'daterange'")
                ods-form-item(prop='secondValueDateRange')
                  ods-date-picker(
                    v-model='filterForm.secondValueDateRange',
                    type='datetimerange',
                    :range-separator='$t("msg_generics.datepicker.separator")',
                    :start-placeholder='$t("msg_generics.datepicker.start_placeholder")',
                    :end-placeholder='$t("msg_generics.datepicker.end_placeholder")',
                    size='mini',
                    @change='getSecondValue',
                    :unlink-panels='true',
                    :picker-options='pickerOptions',
                    value-format='yyyy-MM-ddTHH:mm:ss.SSS',
                    align='right',
                    :format='$t("date_format_long_datepicker")',
                    :default-time="['00:00:00', '23:59:59']",
                    prefix-icon='prefix-icon-date-time-picker',
                    :clearable='false')
              div(v-else)
                ods-form-item.others-input(prop='secondValueNumber')
                  ods-input(
                    :placeholder='selected.placeholder',
                    v-model.number='filterForm.secondValueNumber',
                    @input='getSecondValue')
          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-if="(selected.componente === 'date' && filterForm.tipo === 'daterange')")
              ods-form-item(prop='thirdValue')
                ods-date-picker(
                  v-model='filterForm.thirdValue',
                  type='daterange',
                  :range-separator='$t("msg_generics.datepicker.separator")',
                  :start-placeholder='$t("msg_generics.datepicker.start_placeholder")',
                  :end-placeholder='$t("msg_generics.datepicker.end_placeholder")',
                  size='mini',
                  @change='getThirdValue',
                  :unlink-panels='true',
                  :picker-options='pickerOptions',
                  value-format='yyyy-MM-ddTHH:MM:ss.SSSZ',
                  align='right',
                  :format='$t("date_format_long_datepicker")',
                  prefix-icon='prefix-icon-date-time-picker')
          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-show='filterForm.firstValue')
              ods-button(
                icon='ods-icon-plus',
                size='medium',
                circle,
                @click.native='addButtonAction(selected)')
    b2b-tags-component(
      :key='updateFilterTags',
      :tags='filters',
      @when-remove='deleteParam',
      @when-remove-all='handleDeleteAllFilters')
</template>

<script>
import B2bSearchBar from '@/components/B2bSearchBar'
import B2bFilterButton from '@/components/B2bFilterButton'
import B2bTagsComponent from '@/components/B2bTagsComponent'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-filters-component',
  mixins: [Utils],
  props: {
    filterOptions: {
      type: Object,
      required: true
    },
    defaultFilter: {
      type: Object
    },
    eventListener: {
      type: Object,
      required: false
    },
    showDatePicker: {
      type: Boolean,
      default: () => true
    },
    defaultDateRange: {
      type: Boolean,
      default: () => true
    },
    initialTags: {
      type: Array,
      default: () => []
    },
    initialRange: {
      type: Array,
      default: () => null
    }
  },
  components: {
    B2bSearchBar,
    B2bFilterButton,
    B2bTagsComponent
  },
  data () {
    const _this = this
    return {
      // DatePicker
      dateTimePickerValue: [],
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t('msg_generics.datepicker.today'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'today')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_week'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastWeek')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_month'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastMonth')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_three_months'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastThreeMonths')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_year'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastYear')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_two_year'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastTwoYear')
            }
          }
        ]
      },
      // Query para Emitir en el Evento
      query: {},
      filters: [],
      // Forumlario
      filterForm: {
        secondValueWithoutMin: '',
        firstValue: '',
        secondValue: '',
        secondValueNumber: '',
        secondValueSelect: '',
        thirdValue: '',
        invoiceNumber: '',
        fromRange: '',
        toRange: ''
      },
      selected: {},
      options: {},
      rules: {
        invoiceNumber: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 1, message: this.$t('msg_generics.min_three_letters') },
          { max: 40, message: this.$t('msg_generics.max_num_character', { max: 40 }), trigger: 'change' }
        ],
        firstValue: [
          {
            required: true,
            message: this.$i18n.t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        secondValue: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 1, message: this.$t('msg_generics.min_three_letters') },
          { max: 50, message: this.$t('msg_generics.max_num_character', { max: 50 }), trigger: 'change' }
        ],
        secondValueNumber: [
          {
            required: true,
            message: this.$i18n.t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            type: 'number',
            message: this.$i18n.t('msg_generics.number_required'),
            trigger: 'change'
          }
        ],
        secondValueSelect: [
          {
            required: true,
            message: this.$i18n.t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        thirdValue: [
          {
            required: true,
            message: this.$i18n.t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        fromRange: [
          {
            required: true,
            message: this.$i18n.t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            type: 'number',
            message: this.$i18n.t('msg_generics.number_required'),
            trigger: 'change'
          }
        ],
        toRange: [
          {
            required: true,
            message: this.$i18n.t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            type: 'number',
            message: this.$i18n.t('msg_generics.number_required'),
            trigger: 'change'
          }
        ],
        secondValueDateRange: [
          {
            required: true,
            message: this.$i18n.t('msg_generics.field_required')
          }
        ]
      },
      emitEvents: true,
      updateFilterTags: 0
    }
  },

  methods: {

    disabledDate (time) {
      return time.getTime() > Date.now()
    },

    getFirstValue (data) {
      this.filterForm.invoiceNumber = ''
      this.filterForm.secondValueWithoutMin = ''
      this.filterForm.secondValue = ''
      this.filterForm.secondValueNumber = ''
      this.filterForm.secondValueSelect = ''
      this.$refs.filterForm.clearValidate()
      this.selected = data
    },

    getSecondValue (data) {
      if (this.selected.componente === 'select') {
        this.selected.userValue = data.name
        this.selected.query = data.value
      } else {
        this.selected.query = data
        delete this.selected.userValue
      }
      this.$refs.filterForm.clearValidate()
    },

    getThirdValue (data) {},

    selectDistinctColumn (column) {
      this.$store.dispatch('getDistinctColumn', column).then(response => {
        this.selected.options = this.$store.getters.getDistinctColumn
      })
    },

    addParam (item) {
      this.$refs.filterForm.validate(valid => {
        if (valid) {
          this.selected = {}
          this.addParamTag(item)
          this.$refs.filterForm.resetFields()
          if (this.emitEvents) {
            if (this.eventListener) {
              this.eventListener.$emit('filters-query', this.query)
            } else {
              this.$emit('filters-query', this.query)
            }
          }
          this.initForm()
        }
      })
    },

    addParamTag (item) {
      this.filters = this.filters.filter(
        f => f.prop !== item.prop
      )
      if (item.componente === 'date' && item.tipo === 'daterange') {
        const paramFrom =
          item.prop.length === 2 ? item.prop[0] : item.prop + 'From'
        const paramTo =
          item.prop.length === 2 ? item.prop[1] : item.prop + 'To'
        this.query[paramFrom] = new Date(item.query[0]).toISOString()
        this.query[paramTo] = new Date(item.query[1]).toISOString()
      } else {
        this.query[item.prop] = item.query
      }
      item.selected = true
      this.filters.push(item)
    },

    deleteParam (param) {
      if (param.componente === 'date' && param.tipo === 'daterange') {
        const paramFrom =
          param.prop.length === 2 ? param.prop[0] : param.prop + 'From'
        const paramTo =
          param.prop.length === 2 ? param.prop[1] : param.prop + 'To'
        delete this.query[paramFrom]
        delete this.query[paramTo]
      } else {
        delete this.$data.query[param.prop]
      }

      this.resetOneOption(this.options, param)

      this.$data.filters = this.$data.filters.filter(item => item.prop !== param.prop)
      if (this.$data.emitEvents) {
        if (this.eventListener) {
          this.eventListener.$emit('filters-query', this.$data.query)
        } else {
          this.$emit('filters-query', this.$data.query)
        }
      }
    },

    deleteAllParams () {
      // Reseteamos la prop selected de los filtros
      this.resetSelectedOptions(this.options)

      this.$data.query = {}
      this.$data.filters = []
      if (this.$data.emitEvents) {
        if (this.eventListener) {
          this.eventListener.$emit('filters-query', this.$data.query)
        } else {
          this.$emit('filters-query', this.$data.query)
        }
      }
    },

    addButtonAction (param) {
      this.$data.emitEvents = true
      this.addParam(param)
      this.$data.updateFilterTags = this.$data.updateFilterTags === 0 ? 1 : 0
    },

    // Emite el Evento al Padre con los nuevos Datos de la Fecha
    getDateTimePickerValue () {
      let dates = null
      if (
        this.dateTimePickerValue != null &&
        this.dateTimePickerValue.length === 2
      ) {
        dates = []
        dates.push((new Date(this.dateTimePickerValue[0])).toISOString())
        dates.push((new Date(this.dateTimePickerValue[1])).toISOString())
      }
      if (this.eventListener) {
        this.eventListener.$emit('changeFilterDateTimePicker', dates)
      } else {
        this.$emit('changeFilterDateTimePicker', dates)
      }
    },

    // Calcula y emite el Evento al Padre calculando un Rango de 15 dias anteriores
    getFirstRangeDate () {
      const start = new Date()
      const end = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
      this.dateTimePickerValue.push(start)
      this.dateTimePickerValue.push(end)
    },

    handleDeleteAllFilters () {
      this.deleteAllParams()
      this.initForm()
    },

    initForm () {
      if (this.defaultFilter) {
        this.filterForm.firstValue = this.defaultFilter
        this.selected = this.filterForm.firstValue
      }
    }
  },

  mounted () {
    if (this.initialTags) {
      for (const tag of this.initialTags) {
        this.addParamTag(tag)
      }
    }
    if (this.initialRange) {
      this.dateTimePickerValue = []
      this.dateTimePickerValue.push((new Date(this.initialRange[0])))
      this.dateTimePickerValue.push((new Date(this.initialRange[1])))
    } else if (this.defaultDateRange) {
      this.getFirstRangeDate()
    }
  },

  created () {
    this.options = this.filterOptions
    this.initForm()
    if (this.defaultDateRange) {
      this.getFirstRangeDate()
      if (this.eventListener) {
        this.eventListener.$emit(
          'changeFilterDateTimePicker',
          this.dateTimePickerValue
        )
      } else {
        this.$emit('changeFilterDateTimePicker', this.dateTimePickerValue)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.the-b2b-filters-component {
  ::v-deep .ods-tag--secondary {
    background-color: var(--color-bg-hover-2) !important;
    border-color: transparent !important;
    color: var(--color-bg-interactive) !important;
  }
::v-deep .ods-icon-close, body .ods-icon-close {
    position: relative;
    cursor: pointer;
    font-size: 12px !important;
    height: 8px;
    line-height: 1;
    vertical-align: middle;
    right: -1px;
    top: -4px;
    color: var(--color-bg-interactive);
}
::v-deep .ods-select__tags {
  line-height: inherit;
}
::v-deep .ods-tag {
    display: inline-block;
    height: 24px;
    line-height: 14px;
    background-color: white;
    padding-top: 5px;
    font-size: 9px;
    color: var(--color-bg-interactive);
    border-radius: 6px;
    box-sizing: border-box;
    white-space: nowrap;
    text-transform: uppercase;
    font-family: soho, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, "微软雅黑", Arial, sans-serif;
    font-weight: 600;
    letter-spacing: 0.2px;
    border: 1px solid;
}
::v-deep .ods-select .ods-tag {
    display: inline-flex;
    .ods-tag__content {
      .ods-select__tags-text {
        text-transform: none;
      }
      max-width: 100%;
    min-width: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    width: calc(100% - 8px);
    display: inline-block;
    vertical-align: bottom;
    }
  }
  .ods-button{
    display: inline;
    margin-right: rem(24);
  }

  ::v-deep &__area {
    display: flex;
    flex-direction: row !important;

    .ods-form-item {
      margin-bottom: 0;
      &__content {
        line-height: inherit;
      }
      &__error {
        top: rem(55);
      }
      input {
        max-width: rem(200);
      }
      select {
        max-width: rem(200);
      }
    }

    .first-input {
      margin-right: rem(32);
    }

    // Para los input que no sean datepicker,
    // colocar un margen igual a como si tuviese el botón del datepicker
    .others-input {
      margin-right: rem(16);
    }

    .ods-range-separator {
      padding: 0 rem(8);
    }
  }

  &__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;
  }

  &__button {
    margin: 0 0 0 1.25rem;
    display: inline-block;
    width: auto;
  }

  .ods-icon-delete {
    cursor: pointer;
  }
}
</style>
